/**
 * Toast — эфемерная плашка снизу по центру (тёмная, с зелёным маркером).
 * Управляется хуком `useToast`: рендерит, пока `message` не пуст. Иконку
 * можно переопределить (по умолчанию — точка).
 */

import type {ReactNode} from 'react';

type ToastProps = {
  message: string | null;
  icon?: ReactNode;
};

export const Toast = ({message, icon}: ToastProps) => {
  if (!message) return null;
  return (
    <div className="fixed bottom-6 left-1/2 z-[80] flex -translate-x-1/2 items-center gap-2.5 rounded-[11px] bg-skr-toast px-4 py-2.5 text-[13px] font-medium text-white shadow-lg">
      {icon ?? <span className="size-1.5 rounded-full bg-skr-toast-dot" />}
      {message}
    </div>
  );
};
